export const server = "https://tech-trove1-steel.vercel.app/api";
// export const server = "http://localhost:8000/api";

